export default __webpack_public_path__ + "static/media/primary.8ae8dd6e609de25f39a6c444ef1e755a.svg";